/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment, useEffect, useReducer, useRef } from 'react';

import { EMPTY_STRING } from '../../const';
import optionsReducer from '../../reducers/multiOptions';
import filterMenuStyle from '../FiltersMenu/styles';
import { ToolTipIcon } from '../Icons';
import TooltipInfo from '../TooltipInfo';
import useStyles from './styles';

const programsOptions = [
  {
    id: 1,
    text: 'Comets',
    value: 'Comets',
  },
  {
    id: 2,
    text: 'Disability Rec',
    value: 'DisabilityRec',
  },
  {
    id: 3,
    text: 'Just Play - Kickabout',
    value: 'JustPlayKickabout',
  },
  {
    id: 4,
    text: 'Just Play - Learn to Play',
    value: 'JustPlayLearnToPlay',
  },
  {
    id: 5,
    text: "Squad Girls' Football",
    value: 'SquadGirlsFootball',
  },
  {
    id: 6,
    text: 'Wildcats',
    value: 'Wildcats',
  },
];

const FilterByPrograms = ({
  onSave,
  currentValue,
  onErrorChange,
  filterShowHide,
}) => {
  const styles = useStyles();
  const filterMenuStyles = filterMenuStyle();

  const currentValueArray =
    currentValue && currentValue !== EMPTY_STRING
      ? currentValue.split(',')
      : [];

  const [optionsState, dispatch] = useReducer(
    optionsReducer,
    currentValueArray || []
  );

  const lastSavedValue = useRef(currentValueArray || []);

  // Handle input change
  const handleProgramsOptionsChange = event => {
    const selectedValue = event.target.value;
    const inOptions = !!optionsState.find(value => value === selectedValue);

    if (inOptions) {
      dispatch({ type: 'remove', payload: { value: selectedValue } });
    } else {
      dispatch({ type: 'add', payload: { value: selectedValue } });
    }
  };

  // Call onSave only after currentValue updates
  useEffect(() => {
    if (optionsState !== lastSavedValue.current) {
      const filtersValue =
        optionsState.length === 0
          ? programsOptions.map(program => program.value).join(',') // all programs
          : optionsState.sort().join(',');

      onSave({
        Programs: filtersValue,
        RawPrograms: optionsState, // raw user selection
      });
      lastSavedValue.current = optionsState;
    }
  }, [optionsState, onSave]);

  // for clear filter Sync local state with prop changes
  useEffect(() => {
    const newValueArray =
      currentValue && currentValue !== EMPTY_STRING
        ? currentValue.split(',')
        : [];

    dispatch({ type: 'reset', payload: { value: newValueArray } });
  }, [currentValue]);

  return (
    <Fragment>
      <div css={filterMenuStyles.filterHead}>
        <h5 css={filterMenuStyles.filterTitle}>
          FA Programmes
          <span>
            <TooltipInfo icon={<ToolTipIcon />} headTitle="FA Programmes">
              <>
                <div>
                  England Football Programmes have been created to meet the
                  needs of children and adults of different ages and lifestages.
                  Providers that run these sessions meet standards set by The
                  FA.For more information visit:{' '}
                  <a
                    href="https://www.englandfootball.com/participate/England-Football-Providers"
                    target="_blank"
                    rel="noreferrer"
                    ipInfo
                  >
                    https://www.englandfootball.com/participate/England-Football-Providers
                  </a>
                </div>
              </>
            </TooltipInfo>
          </span>
        </h5>
      </div>
      <div css={filterMenuStyles.filterBody}>
        <ul css={styles.listWrapper}>
          {programsOptions &&
            programsOptions.map(({ id, text, value: optionValue }) => {
              const isChecked = optionsState.includes(optionValue);

              return (
                <li key={optionValue}>
                  <label
                    htmlFor={`program-${id}`}
                    css={styles.chooseFilter(isChecked)}
                    key={optionValue}
                  >
                    <span>{text}</span>
                    <input
                      type="checkbox"
                      id={`program-${id}`}
                      name={`program-${id}`}
                      checked={isChecked}
                      value={optionValue}
                      css={styles.optionCheckbox}
                      onChange={handleProgramsOptionsChange}
                      tabIndex={filterShowHide ? 0 : -1}
                    />
                    <span />
                  </label>
                </li>
              );
            })}
        </ul>
      </div>
    </Fragment>
  );
};

FilterByPrograms.propTypes = {
  currentValue: PropTypes.string,
  onSave: PropTypes.func,
};

export default FilterByPrograms;
